<template>
  <el-header class="admin-header super-header" height="110px">
    <div class="header-container">
      <router-link to="/">
        <div class="header-logo">
          <img src="@/assets/images/layouts/logo.png" alt="" />
        </div>
      </router-link>
      <div class="header-tabs">
        <a href="mailto:support@audiotestkitchen.com">
          <div class="tab-item">
            <span>SUPPORT</span>
          </div>
        </a>
      </div>
    </div>
    <div class="header-info">
      <div class="header-title">
        <span>ATK SUPER PLAYER</span>
      </div>
      <div class="header-user">
        <el-dropdown class="user-dropdown" trigger="click" @command="handleUserDropdown" placement="bottom-end">
          <span class="el-dropdown-link">
            <img src="@/assets/images/layouts/icon_user.png" alt="" />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">Sign out</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'SuperHeader',
  methods: {
    handleUserDropdown: function (command) {
      switch (command) {
        case 'logout':
          this.logout()
      }
    },
    logout () {
      this.$confirm('Confirm to sign out？', 'Tips', {
        confirmButtonText: 'Confirm',
        confirmButtonClass: 'el-btn-red',
        cancelButtonText: 'CANCEL'
      }).then(_ => {
        this.$store.dispatch('logout', {
        }).then(() => {
          this.$router.replace('/login')
        }).catch(err => {
          if (err) {
            this.$message.error(err)
          }
        }).then(() => {
        })
      }).catch(_ => {})
    }
  }
}
</script>

<style scoped lang="scss">
.super-header {
  padding: 0;
  .header-info {
    border-bottom: solid 2px #FFC500;
  }
}
</style>
